// @ts-nocheck
import React from 'react';
import { Router } from '@gatsbyjs/reach-router';
import AppLayout from '../components/layout/AppLayout';
import DocumentPage from '../components/containers/RealtaDocument/DocumentPage';

const Home = () => {
  return (
    <AppLayout>
      <Router>
        <DocumentPage path="/" />
      </Router>
    </AppLayout>
  );
};
export default Home;
